import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getSpecialInfo, getSpecialListBySource, resetSpecialInfo } from '../../actions/special';
// import CardIndex from '../../card/CardIndex/CardIndex';
import Loading from '../../components/Loading/Loading';
import { CONTEXT } from '../../config';
import { getQueryString } from '../../utils/utils';
import styles from './Special.module.less';
import NSpecial from './NSpecial';
import { setTopImgVideoVisible } from '../../actions/layout';
import { useActivate } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectSpecialInfo = createSelector(
  state => state.special,
  special => special.specialInfo,
);

const selectRecommendSpecialList = createSelector(
  state => state.special,
  special => {
    return special.recommendSpecialList;
  },
);

export default memo(() => {
  const [node, setNode] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const specialInfo = useSelector(selectSpecialInfo);
  const ztId = getQueryString('ztId', location.search) || '';
  const bannerId = getQueryString('bannerId', location.search) || '';
  const viewPage = getQueryString('viewPage', location.search) || '';
  const bizInfo = getQueryString('bizInfo', location.search) || '';
  const recommZT = useSelector(selectRecommendSpecialList);

  /**
   * 触发页面滚动效果
   */
  useEffect(() => {
    return () => {
      dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false, data: null }));
      dispatch(resetSpecialInfo({}));
    };
  }, []);
  useEffect(() => {
    if (specialInfo && specialInfo.ztHead) {
      dispatch(
        setTopImgVideoVisible({
          visible: true,
          page: 'special',
          data: {
            img: specialInfo.ztHead,
          },
        }),
      );
    }
    if (specialInfo && specialInfo.isOffLine) {
      history.push(`${CONTEXT}/error`);
      dispatch(resetSpecialInfo({}));
    }
  }, [specialInfo]);
  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Special||${ztId || ''}||${bannerId || ''}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            ztId,
            bannerId,
          },
          param3: bizInfo,
        }),
      );
    };
  }, [ztId, bannerId]);

  /**
   * 处理链接点击事件函数
   * @param {*} element
   */
  const skip = element => () => {
    const { type, content } = element.dataset;
    // eslint-disable-next-line no-param-reassign
    element.style.cssText = 'color:#2262e0;cursor:pointer;';
    switch (type) {
      case 'chain':
        window.open(content);
        break;
      case 'zt':
        history.push(`${CONTEXT}/special?ztId=${content}`);
        break;
      case 'channel':
        // eslint-disable-next-line no-case-declarations
        const path = {
          soft: 'recommend',
          recommend: 'recommend',
          game: 'game',
          'game/gameSelect': 'game',
          work: 'work',
          education: 'education',
          class: 'category',
          category: 'category',
          wprecommend: 'wprecommend',
          rank: 'topn',
          wallpaper: 'wprecommend',
          android: 'arecommend',
          upgrade: 'update',
          uninstall: 'uninstall',
        };
        history.push(`${CONTEXT}/${path[content] || 'recommend'}`);
        break;
      default:
        break;
    }
  };

  /**
   * 注册链接点击事件
   */
  useEffect(() => {
    const els = node && node.querySelectorAll('span[data-type]');
    els &&
      els.forEach(element => {
        element.style.cssText = 'color:#2262e0;cursor:pointer;';
        element.addEventListener('click', skip(element));
      });
    return () => {
      els &&
        els.forEach(element => {
          element.removeEventListener('click', skip(element));
        });
    };
  }, [node, specialInfo && specialInfo.ztList]);

  /**
   * 获取推荐的专题
   */
  useEffect(() => {
    if (specialInfo && specialInfo.ztType && specialInfo.ztId) {
      dispatch(
        getSpecialListBySource({
          params: {
            pageType: 'special',
            ztType: specialInfo.ztType,
            ztId: specialInfo.ztId,
          },
        }),
      );
    }

    if (specialInfo && Object.keys(specialInfo).length > 0 && !specialInfo.ztHead) {
      history.push(`${CONTEXT}/error?sourcePage=Special`);
    }
  }, [specialInfo]);

  useEffect(() => {
    // 如果数据错误
    if (specialInfo && specialInfo.ztId === ztId && specialInfo.isOffLine) {
      history.replace(`${CONTEXT}/error?sourcePage=Special`);
      return;
    }
    if (
      !specialInfo ||
      !specialInfo.ztId ||
      !specialInfo.ztTitle ||
      !specialInfo.ztList ||
      specialInfo.ztId !== ztId
    ) {
      if (ztId) {
        dispatch(getSpecialInfo({ ztId, viewPage }));
      }
    }

    return () => {
      if (specialInfo && specialInfo.ztId && specialInfo.ztType) {
        dispatch(resetSpecialInfo({}));
      }
    };
  }, [dispatch, ztId, viewPage]);

  /**
   * 王林想的优秀的变态的需求，点应用进入专题详情页面并且滚动到指定的应用
   */
  useEffect(() => {
    const scrollToSoft = getQueryString('scrollToSoft', location.search) || '';
    if (
      specialInfo &&
      specialInfo.ztId &&
      specialInfo.ztTitle &&
      specialInfo.ztList &&
      specialInfo.ztId === ztId &&
      scrollToSoft
    ) {
      setTimeout(() => {
        const el = document.querySelector(`[data-softtag='${scrollToSoft}']`);
        el && el.scrollIntoView({ block: 'center' });
      });
    }
  }, [dispatch, specialInfo]);
  useActivate(() => {
    const scrollToSoft = getQueryString('scrollToSoft', location.search) || '';
    if (
      specialInfo &&
      specialInfo.ztId &&
      specialInfo.ztTitle &&
      specialInfo.ztList &&
      specialInfo.ztId === ztId &&
      scrollToSoft
    ) {
      setTimeout(() => {
        const el = document.querySelector(`[data-softtag='${scrollToSoft}']`);
        el && el.scrollIntoView({ block: 'center' });
      });
    }
  });

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Special',
        label: '',
        param2: {
          source: `Special||${ztId || ''}||${bannerId || ''}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source: `Special||${ztId || ''}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.specialOpenPageTime = +new Date();
    loggingPVDuration();
  }, [dispatch, ztId]);

  // 页面浏览时长打桩每隔30秒打一次，限制3分钟内
  const loggingPVDuration = useCallback(() => {
    const spaceTime = 30;
    setTimeout(() => {
      const diffTime = +new Date() - window.specialOpenPageTime;
      if (window.location.pathname.indexOf('special') > -1 && diffTime < 6 * spaceTime * 1000) {
        dispatch(
          logging({
            category: 'I',
            action: 'Special_View_Time',
            label: '',
            param2: {
              source: `Special||${ztId || ''}||${bannerId || ''}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              time: parseInt(diffTime / 1000, 10),
            },
            param3: bizInfo,
          }),
        );
        loggingPVDuration();
      }
    }, spaceTime * 1000);
  }, [dispatch]);

  if (
    !specialInfo ||
    !specialInfo.ztList ||
    !specialInfo.ztList.length ||
    specialInfo.ztId !== ztId
  ) {
    return <Loading />;
  }
  return (
    <div className={styles.special} ref={n => setNode(n)}>
      <NSpecial
        specialInfo={specialInfo}
        recommZT={recommZT}
        bannerId={bannerId}
        viewPage={viewPage}
        ztId={ztId}
        bizInfo={bizInfo}
      />
    </div>
  );
});
